import * as React from 'react';

// If focusing a div or heading, ensure it has `tabIndex={0}` to make it focusable.
const refs: { [key: string]: React.RefObject<HTMLDivElement | HTMLHeadingElement | HTMLInputElement> } = {};

const RefContext = React.createContext(refs);

export const useRefProvider = (...keys: string[]) => {
  const context = React.useContext(RefContext);

  return keys.map(key => {
    const existingValue = context[key];

    return existingValue ? existingValue : (context[key] = React.createRef());
  });
};

export const RefProvider: React.FunctionComponent<{}> = ({ children }) => (
  <RefContext.Provider value={refs}>{children}</RefContext.Provider>
);

RefProvider.displayName = 'RefProvider';
